import React, { useRef, useState, useEffect } from 'react'
import { KnovaText } from '../../BasicUIComponents/KnovaText'
import AssessmentComponents from '../AssessmentComponents'

function LayoutQA(props) {
  const {
    isPractice,
    Completed,
    isActive,
    layoutData,
    themeProperties,
    isSideMenu,
    controlsList,
    isFollowTheFlow,
    priorityActive,
    isClassroom,
    isAudioPlaying,
    isMinimize
  } = props
  const {
    InkJson,
    replayRectangles,
    strokeColor,
    strokeReplayStarted,
    sketchType,
    strokeWidth,
    currentSpeed,
    getCurrentRectangleData,
    getStrokeReplayFinished,
    getReplyStatus,
    isReplaying
  } = props //Replay rectangles variables
  const {
    handleValueChange,
    onPriorityChange,
    handleSucAndFailFeedback,
    onToastTrigger,
    onVideoControlChange,
    handleSelectionStatus
  } = props
  const [textData, setTextData] = useState({})
  const [assesmentBlockData, setAssesmentBlockData] = useState({})
  const [componentDefaultValue, setComponentDefaultValue] = useState()
  const [currentSelectedDropdown, setcurrentSelectedDropdown] = useState(-1)
  const [isOutsideClick, setIsOutsideClick] = useState(false)

  useEffect(() => {
    let textDataCopy = layoutData.filter((e) => e.PluginId === 'SCTextArea')
    let assesmentBlockDataCopy = layoutData.filter(
      (e) => e.PluginId !== 'SCTextArea'
    )
    setTextData(textDataCopy[0])
    if (assesmentBlockDataCopy.length > 0) {
      setAssesmentBlockData(assesmentBlockDataCopy[0])
    } else if (replayRectangles.length > 0) {
      setAssesmentBlockData(replayRectangles[0])
    }
  }, [])

  useEffect(() => {
    if (Object.keys(assesmentBlockData).length > 0) {
      const defltVal = controlsList.find(
        (c) => c.CtlId === assesmentBlockData.ControlID
      )
      const embedDefaultValue = defltVal
        ? {
            ...defltVal,
            CtlValue: defltVal.CtlValue.Answer
          }
        : undefined
      setComponentDefaultValue(embedDefaultValue)
      //  console.log('embedDefaultValue', embedDefaultValue)
    }
  }, [controlsList])

  function renderAssesmentBlock(assesmentComponentData) {
    return (
      <AssessmentComponents
        isPractice={isPractice}
        Completed={Completed}
        isActive={isActive}
        themeProperties={themeProperties}
        assesmentBlockData={assesmentComponentData}
        isSideMenu={isSideMenu}
        componentDefaultValue={componentDefaultValue}
        isOutsideClick={isOutsideClick}
        isFollowTheFlow={isFollowTheFlow}
        priorityActive={priorityActive}
        getCurrentSelectedOption={getCurrentSelectedOption}
        handleValueChange={handleValueChange}
        onPriorityChange={onPriorityChange}
        handleSucAndFailFeedback={handleSucAndFailFeedback}
        //Replay rectangle variables
        InkJson={InkJson}
        strokeColor={strokeColor}
        strokeReplayStarted={strokeReplayStarted}
        sketchType={sketchType}
        strokeWidth={strokeWidth}
        currentSpeed={currentSpeed}
        getCurrentRectangleData={getCurrentRectangleData}
        getReplyStatus={getReplyStatus}
        getStrokeReplayFinished={getStrokeReplayFinished}
        onToastTrigger={onToastTrigger}
        onVideoControlChange={onVideoControlChange}
        isClassroom={isClassroom}
        isAudioPlaying={isAudioPlaying}
        isMinimize={isMinimize}
        isReplaying={isReplaying}
        handleSelectionStatus={handleSelectionStatus}
      />
    )
  }

  function getCurrentSelectedOption(currentSelectedDropdown) {
    setcurrentSelectedDropdown(currentSelectedDropdown)
  }

  if (layoutData.length > 0) {
    return (
      <div
        className='layout-main-cont'
        onClick={() => {
          if (currentSelectedDropdown > -1) {
            setIsOutsideClick(true)
            setTimeout(() => {
              setIsOutsideClick(false)
            }, 1000)
          }
        }}
      >
        <div
          className='layout-ques-cont'
          style={{
            padding: '5% 5% 0 5%',
            filter: isFollowTheFlow
              ? textData.Priority <= priorityActive
                ? 'unset'
                : 'blur(3px)'
              : 'unset'
          }}
        >
          <KnovaText
            text={Object.keys(textData).length > 0 && textData.Value}
            textColor={themeProperties.themeColors.onBackground}
            textFontSize={isSideMenu ? '5px' : '20px'}
            textFontFamily={themeProperties.themeFont.bodyFont}
            textFontWeight='400'
            textHeight='130%'
          />
        </div>
        <div
          className='layout-block-cont'
          style={{
            padding: isSideMenu
              ? '0 3% 3% 3%'
              : assesmentBlockData.PluginName === 'SCAnswerPad'
              ? '0px 5%'
              : '0px 5% 5% 5%'
          }}
        >
          {renderAssesmentBlock(assesmentBlockData)}
        </div>
      </div>
    )
  } else {
    return null
  }
}
export default LayoutQA
